import { defaultTheme } from "react-admin";
import { createTheme } from "@mui/material/styles";
import merge from "lodash/merge";

export const theme = createTheme(
  merge({}, defaultTheme, {
    palette: {
      primary: {
        main: "#000000",
      },
      secondary: {
        main: "#DAC554",
      },
    },
    sidebar: {
      width: 150,
      closedWidth: 50,
    },
  }),
);
